import { default as i18n } from "i18next";
import HttpBackend from "i18next-http-backend";
import BackendAdapter from "i18next-multiload-backend-adapter";
// import LanguageDetector from 'i18next-browser-languagedetector';

import i18nextOptions from "@/../../../shared/locales-config.json";
import missingKeyHandler from "./util/missingKeyHandler";

import { isDevelopment } from "@/environment";

const Backend = new BackendAdapter(null, {
  backend: HttpBackend,
  debounceInterval: 50,
  backendOption: {
    crossDomain: false,
    loadPath: "locales/multi?lng={{lng}}&ns={{ns}}&_=" + Date.now(),
  },
});

i18n
  .use(Backend)
  //.use(LanguageDetector)
  .init({
    lng: i18nextOptions.lng,
    fallbackLng: i18nextOptions.fallbackLng,

    ns: i18nextOptions.ns,
    defaultNS: "app",

    // required for i18next 21+
    nsSeparator: ":",
    keySeparator: ".",

    debug: false,
    appendNamespaceToCIMode: true,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    joinArrays: false,
    returnObjects: false,

    // react i18next special options (optional)
    react: {
      useSuspense: true,
    },

    // handle missing translation keys
    saveMissing: isDevelopment,
    missingKeyHandler: isDevelopment ? missingKeyHandler : () => {},
  });

export { i18n };
